// This is to asynchronously load JS files
// A use-case for this is for 3rd-party for content loaded through client-side,
// where we need to load the embeds only after article is loaded

class FileLoader {
  retrieveDomElement(id) {
    return document.getElementById(id)
  }

  load(url, id) {
    return new Promise((resolve, reject) => {
      if (!id) { reject(new Error('Id is required')) }
      var script = document.createElement('script')
      var current = this.retrieveDomElement(id)
      if (current) {
        current.parentNode.removeChild(current)
      }
      script.setAttribute('id', id)
      script.addEventListener('load', () => resolve(script), false)
      script.addEventListener('error', () => reject(script), false)
      script.src = url
      document.body.appendChild(script)
    })
  }
}

module.exports = FileLoader



// WEBPACK FOOTER //
// ./assets/js/helpers/FileLoader.js